import React, { useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Nav, Tab } from "react-bootstrap";

const chartHeaderData = [
  { title: "Current Year", type: "year1" },
  { title: "Last Year", type: "year2" },
];

const ProjectOverviewChart = (props) => {
  const chartRef = useRef();
  const series = [
    {
      name: "Number of Assigned Candidates",
      type: "column",
      data: props?.data?.currentYear?.map((a) => a.quantity),
    },
    {
      name: "Revenue (&#xa3;)",
      type: "area",
      data: props?.data?.currentYear?.map((a) => a.revenue),
    },
    {
      name: "Qty. of candidates required",
      type: "line",
      data: props?.data?.currentYear?.map((a) => a.jobs),
    },
  ];

  const options = {
    chart: {
      height: props.height,
      type: "line",
      stacked: false,
      toolbar: {
        show: false,
      },
    },

    stroke: {
      width: [0, 1, 1],
      curve: "straight",
      dashArray: [0, 0, 5],
    },
    legend: {
      fontSize: "13px",
      fontFamily: "poppins",
      labels: {
        colors: "#888888",
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "18%",
        borderRadius: 6,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        inverseColors: false,
        shade: "light",
        type: "vertical",
        colorStops: [
          [
            {
              offset: 0,
              color: "var(--primary)",
              opacity: 1,
            },
            {
              offset: 100,
              color: "var(--primary)",
              opacity: 1,
            },
          ],
          [
            {
              offset: 0,
              color: "#3AC977",
              opacity: 1,
            },
            {
              offset: 0.4,
              color: "#3AC977",
              opacity: 0.15,
            },
            {
              offset: 100,
              color: "#3AC977",
              opacity: 0,
            },
          ],
          [
            {
              offset: 0,
              color: "#FF5E5E",
              opacity: 1,
            },
            {
              offset: 100,
              color: "#FF5E5E",
              opacity: 1,
            },
          ],
        ],
        stops: [0, 100, 100, 100],
      },
    },
    colors: ["var(--primary)", "#3AC977", "#FF5E5E"],
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    markers: {
      size: 0,
    },
    xaxis: {
      type: "month",
      labels: {
        style: {
          fontSize: "13px",
          colors: "#888888",
        },
      },
    },
    yaxis: {
      min: 0,
      tickAmount: 4,
      labels: {
        style: {
          fontSize: "13px",
          colors: "#888888",
        },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return y.toFixed(0);
            //+ " points";
          }
          return y;
        },
      },
    },
  };

  const dataSeries = (seriesType) => {
    var columnData = [];
    var areaData = [];
    var lineData = [];
    switch (seriesType) {
      case "year2":
        // columnData = [0,0,0,0,0,0,0,0,0,0,0,0];
        // areaData = [0,0,0,0,0,0,0,0,0,0,0,0];
        // lineData = [0,0,0,0,0,0,0,0,0,0,0,0];
        columnData = props?.data?.lastYear?.map((a) => a.quantity);
        areaData = props?.data?.lastYear?.map((a) => a.revenue);
        lineData = props?.data?.lastYear?.map((a) => a.jobs);
        break;
      case "year1":
        columnData = props?.data?.currentYear?.map((a) => a.quantity);
        areaData = props?.data?.currentYear?.map((a) => a.revenue);
        lineData = props?.data?.currentYear?.map((a) => a.jobs);
        break;
      default:
        columnData = props?.data?.currentYear?.map((a) => a.quantity);
        areaData = props?.data?.currentYear?.map((a) => a.revenue);
        lineData = props?.data?.currentYear?.map((a) => a.jobs);
    }
    chartRef.current.chart.ctx.updateSeries([
      {
        name: "Number of Assigned Candidates",
        type: "column",
        data: columnData,
      },
      {
        name: "Revenue (&#xa3;)",
        type: "area",
        data: areaData,
      },
      {
        name: "Qty. of candidates required",
        type: "line",
        data: lineData,
      },
    ]);
  };

  return (
    <>
      <Tab.Container defaultActiveKey={"Week"}>
        <div className="card-header border-0 pb-0 flex-wrap">
          <h4 className="heading mb-0">Projects Overview</h4>
          <Nav as="ul" className="nav nav-pills mix-chart-tab">
            {chartHeaderData.map((item, index) => (
              <Nav.Item as="li" className="nav-item" key={index}>
                <Nav.Link
                  eventKey={item.title}
                  onClick={() => dataSeries(item.type)}
                >
                  {item.title}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>
        <div className="card-body  p-0">
          <div id="overiewChart">
            <ReactApexChart
              options={options}
              series={series}
              ref={chartRef}
              type="line"
              height={props.height}
            />
          </div>
          <div className="ttl-project">
            <div className="pr-data">
              <h5>
                {props?.data?.lastYear
                  ?.map((a) => a.quantity)
                  .reduce(
                    (accumulator, currentValue) => accumulator + currentValue,
                    0
                  )}
              </h5>
              <span>
                {" "}
                {new Date().getFullYear() - 1} - Number of Assigned Candidates
              </span>
            </div>
            <div className="pr-data">
              <h5>
                {props?.data?.lastYear
                  ?.map((a) => a.jobs)
                  .reduce(
                    (accumulator, currentValue) => accumulator + currentValue,
                    0
                  )}
              </h5>
              <span>
                {" "}
                {new Date().getFullYear() - 1} - Qty. of candidates required
              </span>
            </div>
            <div className="pr-data">
              <h5>
                &#xa3;
                {props?.data?.lastYear
                  ?.map((a) => a.revenue)
                  .reduce(
                    (accumulator, currentValue) => accumulator + currentValue,
                    0
                  )}
              </h5>
              <span> {new Date().getFullYear() - 1} - Revenue</span>
            </div>
          </div>
          <div className="ttl-project">
            <div className="pr-data">
              <h5>
                {props?.data?.currentYear
                  ?.map((a) => a.quantity)
                  .reduce(
                    (accumulator, currentValue) => accumulator + currentValue,
                    0
                  )}
              </h5>
              <span>
                {" "}
                {new Date().getFullYear()} - Number of Assigned Candidates
              </span>
            </div>
            <div className="pr-data">
              <h5>
                {props?.data?.currentYear
                  ?.map((a) => a.jobs)
                  .reduce(
                    (accumulator, currentValue) => accumulator + currentValue,
                    0
                  )}
              </h5>
              <span>
                {" "}
                {new Date().getFullYear()} - Qty. of candidates required
              </span>
            </div>
            <div className="pr-data">
              <h5>
                &#xa3;
                {props?.data?.currentYear
                  ?.map((a) => a.revenue)
                  .reduce(
                    (accumulator, currentValue) => accumulator + currentValue,
                    0
                  )}
              </h5>
              <span> {new Date().getFullYear()} - Revenue</span>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};

export default ProjectOverviewChart;
